

const COMPANY_NAME = 'Madhu Sewing Machine';
const COMPANY_EMAIL = 'madhusewingmachines@gmail.com';
const COMPANY_ADDRESS =
  '216, 1st Cross, Magadi Main Rd, near Prasanna Theater, Vidyaranya Nagar, Bengaluru, Karnataka 560023';

export default function PrivacyPolicy() {
  return (
    <div className="container py-4" style={{ minHeight: '60vh' }}>
      <h2 className="text-center fw-bold">Privacy Policy</h2>
      <div className="mx-auto my-2" style={{ width: 120, height: 4, background: '#000', borderRadius: 4 }} />

      <h5 className="mt-3 fw-bold">Introduction</h5>
      <p>
        Welcome to {COMPANY_NAME}. We respect your privacy and are committed to protecting your personal information.
      </p>

      <h5 className="mt-3 fw-bold">Information We Collect</h5>
      <ul>
        <li>Name, Email, Phone Number</li>
        <li>Device and usage information</li>
      </ul>

      {/* -------- TECHNICIAN ONLY LOCATION SECTION ---------- */}

      <h5 className="mt-4 fw-bold">Technician-Only Location Tracking</h5>
      <p>
        We respect user privacy. The <strong>location of customers/users is never tracked</strong>.
        Only the <strong>technician’s real-time location</strong> is collected and that too strictly
        for service execution purposes.
      </p>

      <ul>
        <li>
          Customer/User location is <strong>NOT collected or stored</strong>.
        </li>
        <li>
          Technician location is collected <strong>only when a job is active</strong>.
        </li>
        <li>
          Location tracking is used to confirm whether the technician is:
          <ul>
            <li>On the way to the customer</li>
            <li>Arrived at the job location</li>
            <li>Completing the assigned service</li>
          </ul>
        </li>
        <li>
          Once the job is completed, technician tracking is <strong>automatically stopped</strong>.
        </li>
        <li>
          Location data is not used for marketing, profiling, or selling purposes.
        </li>
      </ul>

      {/* -------- HOW WE USE LOCATION ---------- */}

      <h5 className="mt-3 fw-bold">How We Use Location Information</h5>
      <ul>
        <li>Track technician job progress</li>
        <li>Notify customers when technician is on the way</li>
        <li>Improve service efficiency and job accuracy</li>
        <li>Prevent service fraud or fake job completion</li>
      </ul>

      {/* -------- DATA SHARING ---------- */}

      <h5 className="mt-3 fw-bold">Sharing of Location Data</h5>
      <ul>
        <li>Location data is shared only with authorized administrators.</li>
        <li>We do not sell or share location data with advertisers.</li>
        <li>Location data is stored securely and auto-deleted after defined retention period.</li>
      </ul>

      {/* -------- USER CONTROL ---------- */}

      <h5 className="mt-3 fw-bold">User Control & Permissions</h5>
      <ul>
        <li>Technicians can disable location permissions anytime from mobile settings.</li>
        <li>Denying location access may affect job assignment & tracking features.</li>
        <li>Customers can use the app fully without enabling location.</li>
      </ul>

      {/* -------- CONTACT ---------- */}

      <h5 className="mt-3 fw-bold">Contact Information</h5>
      <p>
        Email: {COMPANY_EMAIL}
        <br />
        Address: {COMPANY_ADDRESS}
      </p>
    </div>
  );
}
